import Select from "../Select";
import { compose } from "redux";
import { connect } from "react-redux";
import { selectDiscoveryKPIs } from "../../store/reducers";
import Tooltip from "../Tooltip";
import { useString as s } from "../StringProvider";

const SelectLinkedKPIs = ({ kpis, ...props }) => {
  const kpiMappingsPlaceholder = s(
    "createChallenge.popup.kpiMappings.placeholder",
    "Select outcome(s)"
  );
  const sortedKPIs = [...kpis];

  sortedKPIs.sort((a, b) => a.definition.name.localeCompare(b.definition.name));

  const options = sortedKPIs.map((kpi) => {
    return {
      value: kpi.kpiCode,
      label: kpi.definition.name
    };
  });

  return (
    <Select
      mode={"multiple"}
      allowClear
      placeholder={kpiMappingsPlaceholder}
      data-cy={"select-linked-kpis"}
      optionFilterProp="label"
      options={options}
      optionRender={(option) => (
        <Tooltip title={option.data.label} placement={"left"}>
          {option.data.label}
        </Tooltip>
      )}
      {...props}
    />
  );
};

const mapStateToProps = (state) => ({
  kpis: selectDiscoveryKPIs(state)
});

export default compose(connect(mapStateToProps))(SelectLinkedKPIs);
